import moment from 'moment'


export const initialState = {
	currentDates: {
		start: moment().subtract(29, "days"),
		end: moment(),
		startText: moment().subtract(29, "days").format("MMMM D, YYYY"),
		endText: moment().format("MMMM D, YYYY"),
	},
	compareDates: {
		start: false,
		end: false,
		startText: false,
		endText: false,
	},
	compareStatus: false,
}
